module.exports = __webpack_public_path__ + "static/media/skills-mapping-img-001.7d780012.jpg";